import React, { useState } from 'react';
import { Colors } from '../../../utils/theme';
import TabPanel from '../../Common/Layout/TabPanel';
import UserGeneralTab from './UserGeneralTab';
import { getTabStyle } from '../../../utils/styleUtils';
import { Paper, Tab, Tabs } from '@mui/material';
import UserPasswordTab from './UserPasswordTab';

const UserDetails: React.FC = () => {
  const [value, setValue] = useState(0);

  return (
    <Paper
      square
      style={{
        width: '83.6%',
        margin: 'auto',
        marginTop: 57,
        height: 680,
        boxShadow: '0px 10px 20px ' + Colors.third + '66'
      }}
    >
      <Tabs
        value={value}
        indicatorColor="primary"
        textColor="primary"
        onChange={(_, newValue) => setValue(newValue)}
        aria-label="detail-tabs"
        variant="fullWidth"
        centered={true}
        TabIndicatorProps={{ style: { background: 'white' } }}
      >
        <Tab
          id="user-general-tab"
          data-testid="user-general-tab"
          label="General"
          style={getTabStyle(0, value)}
        />
        <Tab
          id="user-password-tab"
          data-testid="user-password-tab"
          label="Password"
          style={getTabStyle(1, value)}
        />
      </Tabs>
      <TabPanel value={value} index={0}>
        <UserGeneralTab />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <UserPasswordTab />
      </TabPanel>
    </Paper>
  );
};

export default UserDetails;
